import React from "react";

import Label from "2g-label";

import { useServerMessage } from "b2b/i18n";
import { ZADOSTI } from "b2b/constants";

import createBaseRenderer from "./createBaseRenderer";

export default createBaseRenderer({
  name: "zadostStavLabel",
  placeholderText: "PRIJATY",
  content: ({ val }) => {
    const message = useServerMessage();
    return (
      <Label type={ZADOSTI.STAV_INFOTYPE[val.name]}>
        {message(val, "stav")}
      </Label>
    );
  }
});
